import { StoreonModule } from 'storeon'
import { useStoreon } from 'storeon/react'
import Utils from 'Utils'

import Shared from 'Services/Shared'

const KEY = 'stagingAuth'

type StateValues = {
  login?: string
  password?: string
}

type State = {
  [KEY]: StateValues
}

type Events = {
  'stagingAuth/set': StateValues
  'stagingAuth/clear': void
}

const INITIAL_STATE: StateValues = {
  login: undefined,
  password: undefined,
}

const stagingAuthModule: StoreonModule<State, Events> = store => {
  store.on('@init', () => ({
    [KEY]: INITIAL_STATE,
  }))
  store.on('stagingAuth/set', (state, payload) => {
    return {
      [KEY]: {
        ...state[KEY],
        ...payload,
      },
    }
  })
  store.on('stagingAuth/clear', () => ({
    [KEY]: INITIAL_STATE,
  }))
}

function getState() {
  return Shared.getStore().get()[KEY]
}

function set(values?: StateValues) {
  const currentLogin = getState().login
  const currentPassword = getState().password
  if (values?.login === currentLogin && values?.password === currentPassword)
    return

  Shared.getStore().dispatch('stagingAuth/set', values)

  Utils.ApolloClient.restartWsClient('main')
  Utils.ApolloClient.restartWsClient('chat')
}
const StagingAuth = {
  set,
}

function useStagingAuth() {
  const { stagingAuth } = useStoreon<State, Events>(KEY)

  return {
    login: stagingAuth.login,
    password: stagingAuth.password,
  }
}

export type { Events, State }
export { KEY, StagingAuth, stagingAuthModule, useStagingAuth }
